import { AccountArrowUpIcon } from './AccountArrowUpIcon';

/**
 * author: Colton Wiscombe
 * id 9F3DF21B-6A76-4916-BA8D-E9EF40D4A01F
 * name account-arrow-up
 * version: 6.2.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/account-arrow-up.svg
 * tags
 * - Account / User 
 */
export const AccountUploadIcon = AccountArrowUpIcon;
export default AccountUploadIcon